// extracted by mini-css-extract-plugin
export default {"tags":"NftTags_tags__jwg+l"};